const AUTH_PAGES = {
  AUTH_HEADER_START_FREE: 'رایگان شروع کنید',
  AUTH_HEADER_ENTER_ACCOUNT: 'ورود به حساب کاربری',
  AUTH_FOOTER_TRUST: 'مورد اعتماد بیش از ۴۰،۰۰۰ کسب و کار آنلاین',

  LOGIN_HEADER_TITLE: 'ورود به رایچت',
  LOGIN_HEADER_SUB_TITLE: 'حساب کاربری ندارید؟',
  LOGIN_HEADER_SIGNUP_TEXT: 'عضو شوید',
  LOGIN_ONE_TIME_VERIFICATION: 'ورود با کد یکبار مصرف!',
  LOGIN_ONE_TIME_VERIFICATION_CLICK: 'کلیک کنید',
  LOGIN_ENTER_WEBAPP_LINK: 'ورود به بخش گفتگو با کاربران',
  LOGIN_FORM_SUBMIT: 'ورود به رایچت',

  SIGNUP_HEADER_TITLE: 'ایجاد حساب کاربری',
  SIGNUP_ALREADY_ACCOUNT: 'از قبل حساب کاربری دارید؟',
  SIGNUP_LOGIN_LINK: 'وارد شوید',
  SIGNUP_SUBMIT_BTN: 'عضویت',
  NAME_PLACEHOLDER: 'نام',
  LAST_NAME_PLACEHOLDER: 'نام خانوادگی',
  EMAIL_PLACEHOLDER: 'ایمیل',
  MOBILE_PLACEHOLDER: 'موبایل - ********۰۹۱',
  PASSWORD_PLACEHOLDER: 'رمز عبور',

  ONE_TIME_FORM_SUBMIT: 'ارسال',
  ONE_TIME_RETURN: 'بازگشت',
  ONE_TIME_OPTION_ONE: 'ایمیل',
  TWO_STEP_OPTION_TWO: 'شماره تلفن',
  DISABLE_TOOLTIP: 'پر کردن فیلد انتخاب شده ضروری می‌باشد!',
  INVALID_EMAIL_TOOLTIP: 'ایمیل وارد شده صحیح نمی‌باشد!',
  INVALID_PHONE_TOOLTIP: 'شماره تلفن وارد شده صحیح نمی‌باشد!',
  ONE_TIME_IMPORT_CODE_PLACEHOLDER: 'کد را وارد کنید...',
  ONE_TIME_IMPORT_CODE_TOOLTIP: 'کد وارد شده باید 4 رقم باشد!',

  LANDING_CARD: {
    TITLE: 'نصب ابزارک',
    SUBTITLE: '',
    COPY_BTN: 'کپی تکه کد',
    FOOTER: `
     در صورتی که از سیستم های مدیریت محتوا مانند وردپرس استفاده میکنید، به
    جای تکه کد بالا، بعد از ورود به داشبورد از بخش تنظیمات می‌توانید پلاگین
    مربوطه را دریافت نمایید.
    `,
    SUBMIT_BTN: 'ورود به داشبورد',
  },

  PAGE_TITLE: 'ورود با کد یکبار مصرف!',
  FORM_DESC: `ابتدا یکی از گزینه های زیر را انتخاب کنید، سپس آدرس ایمیل یا شماره تلفنی که در هنگام عضویت استفاده کرده‌اید را وارد کنید، کد یکبار مصرف برای شما ارسال می‌شود.
  `,
  IMPORT_CODE_DESC: 'کد ارسال شده به ایمیل یا شماره تلفن خود را وارد کنید.',
  WITH_COUNTRY_MOBILE_PLACEHOLDER: 'موبایل',

  SITE_REGISTERED_BEFORE:
    'اين سايت قبلا ثبت شده است. لطفا آدرس سايت ديگری را وارد كنيد.',
  SITE_UN_VALID: 'لطفا آدرس سایت را بدرستی وارد کنید!',
  SITE_FIELDS_EMPTY: 'آدرس وب‌سایت را وارد نمایید',
  UN_VALID_EMAIL: 'ایمیل نامعتبر است',
};

export default AUTH_PAGES;
